/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PreOpSignIn from './pre-op-sign-in';
import PreOpSignInDetail from './pre-op-sign-in-detail';
import PreOpSignInUpdate from './pre-op-sign-in-update';
import PreOpSignInDeleteDialog from './pre-op-sign-in-delete-dialog';

const PreOpSignInRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PreOpSignIn />} />
    <Route path="new" element={<PreOpSignInUpdate />} />
    <Route path=":id">
      <Route index element={<PreOpSignInDetail />} />
      <Route path="edit" element={<PreOpSignInUpdate />} />
      <Route path="delete" element={<PreOpSignInDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PreOpSignInRoutes;
